module.exports = __webpack_public_path__ + "static/media/er.70738db6.svg";